<template>
  <v-app>
    <Header2></Header2>
    <v-main>
      <div :class="fondo">
        <router-view />
      </div>
    </v-main>
    <Footer2></Footer2>
  </v-app>
</template>

<script>
// import Header from "@/layouts/Header.vue";
import Header2 from "@/layouts/Header2.vue";
// import Footer from "@/layouts/Footer.vue";
import Footer2 from "@/layouts/Footer2.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapState(["theme", "mobile", "hideItem", "loading", "idTrack"]),
  },
  components: {
    // Header,
    Header2,
    // Footer,
    Footer2,
  },
  data() {
    return {
      fondo: "background",
    };
  },

  watch: {
    theme() {
      if (this.theme == "dark") {
        this.fondo = "background";
        this.$vuetify.theme.dark = false;
        localStorage.setItem("theme", "light");
      } else if (this.theme == "light") {
        this.fondo = "background";
        this.$vuetify.theme.dark = false;
        localStorage.setItem("theme", "light");
      }
    },
    loading: function () {
      if (this.loading == true) {
        setTimeout(() => {
          if (this.loading == true && this.idTrack == null) {
            this.setLoading(false);
          }
        }, 2000);
      }
    },

    // windowX: function () {
    // 	if (this.windowX < 960) {
    // 		this.setHide(true);
    // 		if (this.windowX < 600) {
    // 			this.setMobile(true);
    // 		} else if (this.windowX >= 600) {
    // 			this.setMobile(false);
    // 		}
    // 	} else if (this.windowX >= 960) {
    // 		this.setHide(false);
    // 	}
    // },
  },
  created() {
    let x = localStorage.getItem("theme");
    //console.log(x);
    if (x != null) {
      this.setTheme(x);
    } else if (x == null) {
      localStorage.setItem("theme", "light");
      this.setTheme("ligth");
    }
  },
  methods: {
    ...mapMutations(["setTheme", "setHide", "setMobile", "setLoading"]),
  },
};
</script>

<style>
.v-main__wrap {
  background-image: url("https://images.unsplash.com/photo-1729006076780-ad0b5313b61e?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D");
  background-size: cover; /* Ajusta la imagen para cubrir el área completa */
  background-position: center; /* Centra la imagen */
  background-repeat: norepeat; /* Evita que la imagen se repita */
  height: auto; /* O el tamaño que necesites */
  width: auto; /* Asegura que ocupe todo el ancho */
}
.background2 {
  background: rgba(103, 103, 103, 0);
  /* background: rgb(173, 173, 173); */
  /* background: linear-gradient(
    180deg,
    rgba(173, 173, 173, 1) 0%,
    rgba(135, 135, 135, 1) 31%,
    rgba(77, 77, 77, 1) 100%
  ); */

  height: 100%;
}
.background {
  background: rgba(103, 103, 103, 0);
  /* background: rgb(173, 173, 173); */
  /* background: linear-gradient(
    180deg,
    rgba(173, 173, 173, 1) 0%,
    rgba(135, 135, 135, 1) 31%,
    rgba(77, 77, 77, 1) 100%
  ); */

  height: 100%;
}

.tWhite {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 15px;
}

.azul {
  color: #236192;
}

.tBlack {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 15px;
}

.titulo {
  font-size: 40px;
  color: rgb(121, 121, 121);
}

.titulo2 {
  font-size: 30px;
  color: rgb(121, 121, 121);
}

.titulo3 {
  font-size: 22px;
  color: rgb(121, 121, 121);
}

.textStandby {
  color: #919191;
  font-size: 18px;
}

.textSuccess {
  color: #3bda10;
  font-size: 18px;
}
.textError {
  color: rgb(255, 86, 86);
  font-size: 18px;
}

.changeZoom {
  zoom: 75%;
}

.my-background2 {
  background-image: url("https://images.unsplash.com/photo-1729006076780-ad0b5313b61e?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: auto;
  width: auto;
}
.my-background {
  background: #585555a6;
  background-image: url("https://images.unsplash.com/photo-1729459101552-3830ac71a95d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 15px;
  height: auto;
  width: auto;
}
</style>
